import {
  ShoppingCart,
  CreditCard,
  Truck,
  Package,
  AlertTriangle,
  MessageSquare,
  Send,
  WifiOff,
  Zap,
  UserCheck,
  Clock,
  type LucideIcon,
} from 'lucide-react';

export type NotificationIconConfig = {
  icon: LucideIcon;
  color: string;
  bg: string;
};

const CONFIGS: Record<string, NotificationIconConfig> = {
  ORDER_CREATED: { icon: ShoppingCart, color: 'text-blue-600', bg: 'bg-blue-100 dark:bg-blue-950' },
  ORDER_STATUS_CHANGED: {
    icon: ShoppingCart,
    color: 'text-blue-600',
    bg: 'bg-blue-100 dark:bg-blue-950',
  },
  ORDER_CANCELLED: { icon: ShoppingCart, color: 'text-destructive', bg: 'bg-destructive/10' },
  PAYMENT_FAILED: { icon: CreditCard, color: 'text-destructive', bg: 'bg-destructive/10' },
  DELIVERY_EXCEPTION: {
    icon: Truck,
    color: 'text-orange-600 dark:text-orange-400',
    bg: 'bg-orange-100 dark:bg-orange-950',
  },
  LOW_STOCK: {
    icon: AlertTriangle,
    color: 'text-yellow-600 dark:text-yellow-400',
    bg: 'bg-yellow-100 dark:bg-yellow-950',
  },
  OUT_OF_STOCK: { icon: Package, color: 'text-destructive', bg: 'bg-destructive/10' },
  TICKET_CREATED: {
    icon: MessageSquare,
    color: 'text-purple-600 dark:text-purple-400',
    bg: 'bg-purple-100 dark:bg-purple-950',
  },
  TICKET_ASSIGNED: {
    icon: MessageSquare,
    color: 'text-purple-600 dark:text-purple-400',
    bg: 'bg-purple-100 dark:bg-purple-950',
  },
  POST_PUBLISHED: {
    icon: Send,
    color: 'text-green-600 dark:text-green-400',
    bg: 'bg-green-100 dark:bg-green-950',
  },
  POST_PUBLISH_FAILED: { icon: Send, color: 'text-destructive', bg: 'bg-destructive/10' },
  REPLY_FAILED: { icon: Send, color: 'text-destructive', bg: 'bg-destructive/10' },
  CHANNEL_DISCONNECTED: { icon: WifiOff, color: 'text-destructive', bg: 'bg-destructive/10' },
  WORKFLOW_FAILED: {
    icon: Zap,
    color: 'text-orange-600 dark:text-orange-400',
    bg: 'bg-orange-100 dark:bg-orange-950',
  },
  TICKET_REMINDER: {
    icon: Clock,
    color: 'text-indigo-600 dark:text-indigo-400',
    bg: 'bg-indigo-100 dark:bg-indigo-950',
  },
};

const DEFAULT_CONFIG: NotificationIconConfig = {
  icon: UserCheck,
  color: 'text-muted-foreground',
  bg: 'bg-muted',
};

export function getNotificationIconConfig(type: string): NotificationIconConfig {
  return CONFIGS[type] || DEFAULT_CONFIG;
}
